import { memo } from 'react';
import { getCDNImageUrl } from '../../components/BiImage/utils/index.mjs';
import { jsx } from 'react/jsx-runtime';

const BiDefaultCapital = /*#__PURE__*/memo(_ref => {
  let {
    width = 42,
    height = 42,
    lazyLoading,
    corpId
  } = _ref;
  return /*#__PURE__*/jsx("img", {
    src: getCDNImageUrl('BiDefaultCapital'),
    width: width,
    height: height,
    alt: `Unknown Capital BI for ${corpId}`,
    loading: lazyLoading ? 'lazy' : 'eager'
  });
});
BiDefaultCapital.displayName = 'BiDefaultCapital';
const BiDefaultCd = /*#__PURE__*/memo(_ref2 => {
  let {
    width = 38,
    height = 60,
    lazyLoading,
    corpId
  } = _ref2;
  return /*#__PURE__*/jsx("img", {
    src: getCDNImageUrl('BiDefaultCd'),
    width: width,
    height: height,
    alt: `Unknown Card BI for ${corpId}`,
    loading: lazyLoading ? 'lazy' : 'eager'
  });
});
BiDefaultCd.displayName = 'BiDefaultCd';
const BiDefaultIs = /*#__PURE__*/memo(_ref3 => {
  let {
    width = 42,
    height = 42,
    lazyLoading,
    corpId
  } = _ref3;
  return /*#__PURE__*/jsx("img", {
    src: getCDNImageUrl('BiDefaultIs'),
    width: width,
    height: height,
    alt: `Unknown Insurance BI for ${corpId}`,
    loading: lazyLoading ? 'lazy' : 'eager'
  });
});
BiDefaultIs.displayName = 'BiDefaultIs';
const BiDefaultIv = /*#__PURE__*/memo(_ref4 => {
  let {
    width = 42,
    height = 42,
    lazyLoading,
    corpId
  } = _ref4;
  return /*#__PURE__*/jsx("img", {
    src: getCDNImageUrl('BiDefaultIv'),
    width: width,
    height: height,
    alt: `Unknown Invest BI for ${corpId}`,
    loading: lazyLoading ? 'lazy' : 'eager'
  });
});
BiDefaultIv.displayName = 'BiDefaultIv';
const BiDefaultSb = /*#__PURE__*/memo(_ref5 => {
  let {
    width = 42,
    height = 42,
    lazyLoading,
    corpId
  } = _ref5;
  return /*#__PURE__*/jsx("img", {
    src: getCDNImageUrl('BiDefaultSb'),
    width: width,
    height: height,
    alt: `Unknown SaveBank BI for ${corpId}`,
    loading: lazyLoading ? 'lazy' : 'eager'
  });
});
BiDefaultSb.displayName = 'BiDefaultSb';

export { BiDefaultCapital, BiDefaultCd, BiDefaultIs, BiDefaultIv, BiDefaultSb };
